import React from 'react';
import { BillConceptos } from '../../../models/Factura';
import { formatCurrencyStyled } from '../../visuals/currency.formatted';

interface BillEventsConceptosProps {
    conceptos: BillConceptos[];
    /** The original bill rounds tasas to 4 decimals, its derived bills to 5 */
    tasaRoundFactor?: number;
}

function BillEventsConceptos({ conceptos, tasaRoundFactor = 100000 }: BillEventsConceptosProps) {
    const taxLabel = (tax: BillConceptos['impuestos'][0]) => (
        tax.tasa ? `${Math.round((tax.tasa * 100) * tasaRoundFactor) / tasaRoundFactor}%` : (tax.cuota ? `$ ${Math.round(tax.cuota * 100) / 100} / unidad` : '0%')
    )
    return (
        <div className="conceptosWrap">
            <span className="label">Conceptos:</span>
            {conceptos.map((concepto, i) => (
                <div className="concepto" key={i}>
                    <p>#{i + 1}</p>
                    <p className="_name">{concepto.descripcion}</p>
                    <div className="_claves">
                        <p><span>Clave ProdServ:</span> {concepto.claveProdServ}</p>
                        <p><span>Clave Unidad:</span> {concepto.claveUnidad}</p>
                    </div>
                    <p className="_cantidad">
                        (x{concepto.cantidad})
                    </p>
                    <p className="_valor">
                        {formatCurrencyStyled(concepto.valorUnitario)}
                    </p>
                    <div className="_impuestos">
                        {concepto.impuestos.map((tax, i) => (
                            <p key={i}>
                                {tax.type.toUpperCase()}{tax.retencion ? ' retenido: ' : ':'} {taxLabel(tax)}
                            </p>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default BillEventsConceptos;
